import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';

export const hydrateSession = async (routine) => {
  try {
    // Fetch metadata for every exercise in the routine
    const exercisePromises = routine.exercises.map(async (item) => {
      const exerciseRef = doc(db, 'exercises', item.exerciseId);
      const exerciseSnap = await getDoc(exerciseRef);
      
      if (exerciseSnap.exists()) {
        return {
          ...item, // Includes original order
          ...exerciseSnap.data(), // Includes name, targetMuscle
        };
      }
      return { ...item, name: "Unknown Exercise" };
    });

    const hydratedExercises = await Promise.all(exercisePromises);

    // Return the structured session object
    return {
      routineId: routine.id,
      routineName: routine.name,
      exercises: hydratedExercises.sort((a, b) => a.order - b.order),
      startTime: new Date().toISOString(),
      status: 'active'
    };
  } catch (error) {
    console.error("Hydration Failed: Mission Data Corrupt", error);
    throw error;
  }
};